import { render } from "./DeployVMFromBackup.vue?vue&type=template&id=5a856984&scoped=true"
import script from "./DeployVMFromBackup.vue?vue&type=script&lang=js"
export * from "./DeployVMFromBackup.vue?vue&type=script&lang=js"

import "./DeployVMFromBackup.vue?vue&type=style&index=0&id=5a856984&lang=less&scoped=true"
import "./DeployVMFromBackup.vue?vue&type=style&index=1&id=5a856984&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a856984"]])

export default __exports__